import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  { id: 1, title: "Home", link: "/" },
  { id: 2, title: "About Us", link: "/about" },
  {
    id: 3,
    title: "Services",
    link: "/service",
    submenu: [
      { id: 31, title: "Instagram Services", link: "/service/instagram" },
      { id: 32, title: "TikTok Services", link: "/service/tiktok" },
      { id: 33, title: "YouTube Services", link: "/service/youtube" },
      { id: 34, title: "Facebook Services", link: "/service/facebook" },
      { id: 35, title: "Telegram Services", link: "/service/telegram" },
      { id: 36, title: "Twitter / X Services", link: "/service/twitter-x" },
    ],
  },
  { id: 4, title: "Blog", link: "/blog" },
  { id: 5, title: "Contact Us", link: "/contact" },
];

const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => handleToggle(menu.id)}>
                {menu.title}
                <i
                  className={
                    openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"
                  }
                ></i>
              </p>

              {/* MUI Collapse for smooth animation */}
              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      <Link to={sub.link} onClick={handleClick}>
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
